module.exports = __webpack_public_path__ + "static/media/novice.3c22fbca.png";